import { render, staticRenderFns } from "./BirthView.vue?vue&type=template&id=537cbb1e&scoped=true"
import script from "./BirthView.vue?vue&type=script&lang=js"
export * from "./BirthView.vue?vue&type=script&lang=js"
import style0 from "./BirthView.vue?vue&type=style&index=0&id=537cbb1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537cbb1e",
  null
  
)

export default component.exports